export enum PipelineRunTabs {
  PIPELINE = 'pipeline',
}

export const pipelineRunTabs = [{id: PipelineRunTabs.PIPELINE, title: 'Pipeline'}]
